import { CookieType } from '../helpers/enums';

export const isHidden = (el: HTMLElement | null) => {
  if (!el) {
    return true;
  }
  const style = window.getComputedStyle(el);
  return style.display === 'none';
};

export const stripTrailingSlash = (str: string) => {
  return str.endsWith('/') ? str.slice(0, -1) : str;
};

export const regex = {
  EMAIL:
    /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|""(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*"")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
};

export const sendEvent = (name: string, info: object) =>
  document.dispatchEvent(new CustomEvent(name, { detail: info }));

export const utilShowHideChat = (show: boolean) => {
  const akinChat = document.querySelectorAll('.akin-ai-chat')[0] as HTMLElement;
  if (akinChat) {
    akinChat.style.display = show ? 'block' : 'none';
  }

  if (window['fcWidget'] && window['fcWidget'].isLoaded()) {
    if (show) {
      window['fcWidget'].show();
    } else {
      window['fcWidget'].hide();
    }
  }
};

export const utilLiveChatLoaded = () => {
  const akinChat = document.querySelectorAll('.akin-ai-chat')[0] as HTMLElement;
  if (akinChat) {
    return true;
  }
  if (window['fcWidget'] && window['fcWidget'].isLoaded()) {
    return true;
  }
  return false;
};

export const utilShowLiveChat = () => {
  utilShowHideChat(true);
};

export const utilHideLiveChat = () => {
  utilShowHideChat(false);
};

export const utilOpenLiveChat = () => {
  const akinChat = document.getElementById('akin-chat-button');
  if (akinChat) {
    akinChat.click();
  }
  if (window['fcWidget'] && window['fcWidget'].isLoaded()) {
    window['fcWidget'].open();
  }
};

export const objectHasKeys = (obj) => obj != null && !!Object.keys(obj).length;

export const setCookieTypeAndValue = (cookieType: CookieType, value: string) => {
  const d = new Date();
  d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();

  document.cookie = `${cookieType}=${value.toLowerCase()}; path=/; samesite=lax; domain=${window.location.hostname
    .split('.')
    .slice(-2)
    .join('.')}; expires=${expires};`;
};

/* Set starting value on dropdowns on load of page */
export const setCookieDropdownValue = (cookieType: CookieType) => {
  const cookie = document.cookie.match(new RegExp(`(^| )${cookieType}=([^;]+)`));

  if (!cookie) {
    return;
  }

  const currentLang = cookie[2].toLowerCase();

  const options = document.querySelectorAll<HTMLSelectElement>(`[js-set-active-${cookieType}]`);

  /* Loop through each language dropdown, different process for native and custom dropdowns */
  options.forEach((option) => {
    /* Native dropdown */
    if (option.tagName.toLowerCase() === 'select') {
      option.value = currentLang;
    } else {
      /* Custom dropdown */

      /* Get text value of dropdown with matching language value */
      const textContent = option.querySelector(`[value="${currentLang}"]`)?.textContent;

      /* Get button */
      const button = option.querySelector('[js-custom-select-button]');

      if (!textContent || !button) {
        return;
      }

      /* Apply correct language text */
      button.textContent = textContent;
    }
  });
};

let headerCurrency: string;
let headerLanguage: string;
let selectedCurrencyTitle: string;
let selectedCurrencySymbol: string;

export const setCookieCombinedButtonValue = (cookieType: CookieType) => {
  const cookie = document.cookie.match(new RegExp(`(^| )${cookieType}=([^;]+)`));

  if (!cookie) {
    return;
  }

  const current = cookie[2].toLowerCase();

  const options = document.querySelectorAll<HTMLDivElement>(`[js-set-header-active-${cookieType}]`);

  options.forEach((option) => {
    /* Get text value of option with matching language / currency value */

    const textContent = option.querySelector(`[value="${current}"]`)?.textContent;

    if (!textContent) {
      return;
    }

    if (cookieType === 'language') {
      headerLanguage = textContent;
    } else {
      headerCurrency = textContent;

      const currencyFullTitle = option.querySelector(`[value="${current}"]`)?.querySelector('[js-currency-full-title]');
      const currencyCode = option.querySelector(`[value="${current}"]`)?.querySelector('[js-currency-code]');
      const currencySymbol = option.querySelector(`[value="${current}"]`)?.querySelector('.currency-symbol');

      if (currencySymbol?.textContent?.length) {
        selectedCurrencySymbol = currencySymbol?.textContent?.replace(/[()]/g, '');
      }

      //  set the tab title
      if (currencyFullTitle?.textContent?.length && currencySymbol?.textContent) {
        selectedCurrencyTitle = `${currencyFullTitle?.textContent} ${currencySymbol?.textContent}`;
      } else if (currencyCode?.textContent?.length) {
        selectedCurrencyTitle = `${currencyCode?.textContent} ${currencySymbol?.textContent}`;
      }
    }

    const optionLists = option.querySelectorAll('button[role=option]') as NodeListOf<HTMLButtonElement>;

    const optionListsArray = Array.from(optionLists);

    const selectedButton = optionListsArray.find((optionButton) => optionButton.value === current);

    if (selectedButton) {
      selectedButton.classList.add('clickable-list-items__item--selected');
    }
  });

  const combinedButton = document.querySelector('[js-custom-combined-currency-button]');

  const currencyButton = document.querySelector('[js-custom-currency-button]');
  const languageButton = document.querySelector('[js-custom-language-button]');

  if (headerCurrency) {
    if (window.innerWidth > 1024) {
      const currencyTabLabel = document.getElementById('tab-currency');
      const languageTabLabel = document.getElementById('tab-language');

      const langCookie = document.cookie.match(new RegExp(`(^| )language=([^;]+)`));

      if (!langCookie) return;

      const currentLangCookie = langCookie[2].toLowerCase();

      const langShortName = document
        .querySelector(`[js-set-language][value="${currentLangCookie}"]`)
        ?.getAttribute('js-set-language-short');

      if (!combinedButton || !currencyTabLabel || !languageTabLabel || !langShortName) {
        return;
      }

      combinedButton.textContent = `${selectedCurrencySymbol} / ${langShortName}`;
      languageTabLabel.textContent = headerLanguage;
      currencyTabLabel.textContent = selectedCurrencyTitle;
    } else {
      if (!currencyButton || !languageButton) {
        return;
      }
      languageButton.textContent = headerLanguage;
      currencyButton.textContent = selectedCurrencyTitle;
    }
  }
};

export const trapFocus = (element: HTMLElement) => {
  const focusableEls = [
    ...element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    )
  ] as HTMLElement[];
  const visibleFocusableEls = focusableEls.filter((x) => x.offsetWidth !== 0 || x.offsetHeight !== 0);
  const firstFocusableEl = visibleFocusableEls[0];
  const lastFocusableEl = visibleFocusableEls[visibleFocusableEls.length - 1];

  element.addEventListener('keydown', function (e) {
    const isTabPressed = e.key === 'Tab';

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });
};

export const setBackdropState = (root: HTMLElement, isOpen: boolean, trapUserFocus: boolean = false) => {
  const body = document.querySelector('body')!;
  const main = document.querySelector('main')!;

  /* Increase z-index of main so that modal is not obscured by footer components  */
  main.classList[isOpen ? 'add' : 'remove']('z-index--8');

  /* remove overflow on body so that page behind modal cannot scroll */
  body.classList[isOpen ? 'add' : 'remove']('overflow--hidden');

  /* Show / Hide backdrop */
  root.classList[isOpen ? 'add' : 'remove']('backdrop-active');

  if (trapUserFocus && isOpen && root) {
    setTimeout(() => {
      const firstItem = root.querySelectorAll('button, input')[0] as HTMLElement;
      if (firstItem) {
        firstItem.focus();
      }
      trapFocus(root);
    }, 1000);
  }
};
